import moment from 'moment';
import { GroupedMessage, Message } from '../types/channel.types';
import { SearchDatum } from '../types/v2/react';
/**
 *
 * @param object any object
 * @returns true if the object empty, else otherwise
 */
export function isObjectEmpty(object: {}): boolean {
  return Object.keys(object).length === 0;
}

/**
 *
 * @param str string of interest
 * @returns Hex color code representation of string
 */
export function stringToColor(str: string): string {
  var hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  var color = '#';
  for (let i = 0; i < 3; i++) {
    var value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).substr(-2);
  }
  return color;
}

/**
 *
 * @param date
 * @returns Unix integer representation
 */
export const convertToUnixInt = (date: Date) =>
  parseInt(moment(date).format('X'));
// merge functions
export const convertDateToX = (date: string | Date, dateFormat: string) =>
  parseInt(moment(date, dateFormat).format('x'));

/**
 *
 * @param dateA
 * @param dateB
 * @returns positive number if B > A, negative number if B < A and 0 if B = A
 */
export const dateSort = (dateA: Date, dateB: Date) =>
  convertToUnixInt(dateB) - convertToUnixInt(dateA);

// TODO: use memoization when using this method
/**
 *
 * @param searchValue search text
 * @param data the list of data to be used for the search
 * @returns the data that matches the search
 */
export function searchForValue(searchValue: string, data: SearchDatum[]) {
  // generate the expression for the search string
  const searchExpression = new RegExp(`^${searchValue.toLowerCase()}`);

  // search for the string that matches
  const items = data
    .map((datum: SearchDatum) => {
      const matches = datum.title.toLowerCase().match(searchExpression);
      if (!matches || searchValue.length === 0) {
        return null;
      } else {
        return datum;
      }
    })
    .filter((user) => user);

  return items;

  // ascending order sort
  // const sortResult = items.sort((a, b) => {
  //   if (a && b) {
  //     if (a > b) return 1;
  //     else if (a < b) return -1;
  //     return 0;
  //   }
  //   return 0;
  // });

  // return sortResult;
}

// TODO: use memoization when using this method
/**
 *
 * @param targetSpace expects an array of objects with an id key
 * @param matchSpace expects an array of objects with an id key
 * @param key the key to be matched in the target space, defaulted to 'id'
 * @returns the intersection of the target space and the match space by using an id checker
 */
export function itemsBetween(targetSpace: any, matchSpace: any, key = 'id') {
  const formattedMatchSpace = matchSpace.map((item: any) => item?.id);

  const results = [];
  for (const item of targetSpace) {
    if (formattedMatchSpace.includes(item?.[key])) {
      results.push(item);
    }
  }
  return results;
}

/**
 * This function checks whether a date is  within a certain time period (i.e. within a week or month)
 *
 * @param period a time period (week/month)
 * @param date the date to check
 * @returns true if the date is within the time period specified
 */

export function occursInThis(period: 'week' | 'month', date: Date) {
  return (
    convertDateToX(date, 'll') >
      parseInt(moment().startOf(period).format('x')) &&
    convertDateToX(date, 'll') < parseInt(moment().endOf(period).format('x'))
  );
}

/**
 *
 * @param events A list of events
 * @returns a grouped list of events, grouped by date i.e. each date will be associated with a list of events that occur of that date
 */

export function groupByDate<T>(items: T[]) {
  const groupedEvents: { [key: string]: T[] } = {};
  for (let item of items) {
    // @ts-ignore: Object is possibly 'null'.
    let currentKey = moment(item.date).format('ll');
    if (!groupedEvents[currentKey]) {
      groupedEvents[currentKey] = [item];
    } else {
      groupedEvents[currentKey].push(item);
    }
  }
  return groupedEvents;
}

export const groupMessages = (messages: Message[]): GroupedMessage[] => {
  const groupedMessages: GroupedMessage[] = [];

  let current = 0;
  let end = messages.length - 2;

  while (current <= end) {
    let groupedMessage: GroupedMessage = {
      user: messages[current].user,
      messages: [messages[current].message],
    };

    let nextOccuringMessages: string[] = [];
    let next = current + 1;
    while (next < end + 1) {
      if (messages[current].user.username === messages[next].user.username) {
        nextOccuringMessages = [
          ...nextOccuringMessages,
          messages[next].message,
        ];
      } else {
        break;
      }
      next++;
    }
    current = next;

    if (nextOccuringMessages.length) {
      groupedMessage = {
        ...groupedMessage,
        messages: [...groupedMessage.messages, ...nextOccuringMessages],
      };
    }

    groupedMessages.push(groupedMessage);
  }
  return groupedMessages;
};
